var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14.476,
  height: 15.46,
  viewBox: "0 0 14.476 15.46"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M87.407,4.837l-5.225,5.58A28.991,28.991,0,0,1,79.4,13.027l-2.486,2.037a1.2,1.2,0,0,1-1.628.136h0a1.414,1.414,0,0,1,.127-1.739l1.907-2.655a29.741,29.741,0,0,1,2.443-2.974l5.225-5.58a8.714,8.714,0,0,1,2.4-1.835c.746-.376,1.54-.611,1.925-.2s.165,1.259-.187,2.056A9.281,9.281,0,0,1,87.407,4.837Z",
  transform: "translate(-75.039)",
  fill: "#e0f3fc"
})));
export default __webpack_public_path__ + "static/media/shipping.78b2beb4.svg";
export { SvgComponent as ReactComponent };